<template>
    <v-container style="max-width:100vw;">
        <!--header-->
        <v-toolbar flat class="px-4 py-3">
            <v-toolbar-title>
                Soporte
            </v-toolbar-title>
        </v-toolbar>
        <div>
            {{columns}}
        </div>
    </v-container>
</template>

<script>
import Create from "../support/create"
import Detail from "../support/detail"
import { mapActions, mapGetters } from 'vuex';
import draggable from 'vuedraggable';
export default {
    components: {
        'create':Create,
        'detail':Detail,
        draggable
    },
    data() {
        return {
            columns:[]
        };
    },
    computed: {
        ...mapGetters(['allStories', 'isLoading', 'error']),
    },
    watch: {
        allStories(newStories) {
    console.log("Nuevas historias", newStories);  // Agregado para depuración
    this.columns = this.formatColumns(newStories);
  }
    },
    mounted() {
        this.fetchStoriesWithChildren();
    },
    methods: {
        ...mapActions(['fetchStoriesWithChildren', 'createTaskUnderStory']),

        // Método para formatear las User Stories en columnas de un tablero Kanban
        formatColumns(stories) {
            return stories;
        },

        // Abrir el diálogo para crear una tarea
        openCreateTaskDialog(userStoryId) {
            this.selectedUserStoryId = userStoryId;
            this.createTaskDialog = true;
        },

        // Crear una nueva tarea
        createTask() {
        if (!this.newTaskTitle || !this.newTaskDescription) return;

        this.createTaskUnderStory({
            parentId: this.selectedUserStoryId,
            title: this.newTaskTitle,
            description: this.newTaskDescription,
            estimatedHours: 8,
            startDate: new Date().toISOString()
        }).then(() => {
            this.createTaskDialog = false;
            this.newTaskTitle = '';
            this.newTaskDescription = '';
        });
        },

        // Abrir el diálogo de edición de tarea
        openEditTaskDialog(task) {
        this.editedTask = { ...task };
        this.editTaskDialog = true;
        },

        // Guardar los cambios en la tarea editada
        saveEditTask() {
        this.createTaskUnderStory({
            parentId: this.editedTask.id,
            title: this.editedTask.fields['System.Title'],
            description: this.editedTask.fields['System.Description'],
            estimatedHours: 8,
            startDate: new Date().toISOString()
        }).then(() => {
            this.editTaskDialog = false;
        });
        },

        // Método que se llama cuando se termina el arrastre de una tarea
        onDragEnd(evt) {
        console.log('Drag Ended', evt);
        }
    }
}
</script>

<style>
    .pending {
        background-color: #fff5d7
    }
    .cursor-detail{
        cursor: pointer;
    }
</style>